// extracted by mini-css-extract-plugin
export default {"root":"LogoLink__root___iCXmu","focus-visible":"LogoLink__focus-visible___h2ZPq"};